import DataTable from "../../../../vendor/assets/javascripts/limitless_kit/plugins/tables/datatables/datatables.min";

globalThis.DataTable = DataTable();
